<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<h2 class="part"><em class="italic">Part 1</em></h2>
<h2 class="part-title"><span class="bold">THE CRIME</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Part01.vue?7d8f8c0c